<template>
  <div class="purchase-items">
    <div class="purchase-items__header">
      <span class="purchase-items__header__title">
        {{
          $t('ec-line009.purchaseInfo.orderDate', {
            val: Utils.date.getDateString(data.order_date, Constants.FORMAT_DATE),
          })
        }}
      </span>
      <div v-if="data.subscription_id" class="purcahse-subscription-icon">
        <p>{{ $t('ec-line009.purchaseInfo.subscription') }}</p>
      </div>
    </div>
    <div class="purchase-items__list" v-for="item in data.order_item" :key="item.id">
      <div class="purchase-items__list__card">
        <img :src="getImage(item)" class="purchase-items__list__card__image" />
        <div class="purchase-items__list__card__name">
          <p>{{ item.product_name }}</p>
        </div>
      </div>
    </div>
    <div class="flex gap-x-2 justify-end">
      <div v-if="data.enable_download_delivery_slip" class="text-right">
        <el-button class="delivery-slip-download-btn mt-2 lg:mt-4" @click="handleExportClick">
          {{ $t('ec-line009.purchaseInfo.deliverySlipDownload') }}
        </el-button>
      </div>
      <div v-if="!data.subscription_id" class="text-right">
        <el-button class="section__button repurchase-btn mt-2 lg:mt-4" @click="goToLpCart">
          {{ $t('ec-line009.purchaseInfo.rePurchase') }}
        </el-button>
      </div>
    </div>
    <hr v-if="!isLastItem" class="my-6" />
    <confirm-dialog-2
      v-loading="loading"
      class="export-delivery-slip-dialog"
      :visible.sync="visibleDeliverySlipDownloadDialog"
      :title="$t('ec-line009.purchaseInfo.deliverySlipDownloadDialog.title')"
    >
      <template #content>
        <div>
          <pre class="pause-subscription__font whitespace-pre-line text-left text-base">
            {{ $t('ec-line009.purchaseInfo.deliverySlipDownloadDialog.content') }}
          </pre>
          <pre
            v-if="isLineBrowser"
            class="pause-subscription__font whitespace-pre-line text-left text-base block lg:hidden"
          >
            <span>{{ $t('ec-line009.purchaseInfo.deliverySlipDownloadDialog.spLineContentPrefix') }}</span>
            <a :href="mypageLink" class="text-blue-650 underline">{{ $t('ec-line009.purchaseInfo.deliverySlipDownloadDialog.spLineContentLink') }}</a>
            <span>{{ $t('ec-line009.purchaseInfo.deliverySlipDownloadDialog.spLineContentSuffix') }}</span>
          </pre>
        </div>
      </template>
      <template #action>
        <div class="flex flex-col-reverse lg:flex-row gap-5 justify-center items-center">
          <el-button class="confirm-dialog-2__btn cancel-btn mt-0" @click="visibleDeliverySlipDownloadDialog = false">
            {{ $t('common.action.close') }}
          </el-button>
          <el-button v-if="!isLineBrowser" class="confirm-dialog-2__btn submit-btn mt-0" @click="exportDeliverySlip">
            {{ $t('ec-line009.purchaseInfo.deliverySlipDownloadDialog.downloadBtn') }}
          </el-button>
        </div>
      </template>
    </confirm-dialog-2>
  </div>
</template>

<script>
import { ENV_KEY } from '@/constants/env'
import { TEMPLATE_TYPE_NAME, FILE_PATH_TEMPLATE } from '@/constants'
import { FileService } from '@/services'
import ConfirmDialog2 from '@/components/ConfirmDialog2.vue'
import { downloadFile } from '@/utils'
export default {
  name: 'PurchaseItems',
  components: { ConfirmDialog2 },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    isLastItem: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      loading: false,
      visibleDeliverySlipDownloadDialog: false,
    }
  },

  computed: {
    mypageLink() {
      return `${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}/sh/mypage?openExternalBrowser=1`
    },
    userAgent() {
      return window.navigator.userAgent.toLowerCase()
    },
    isLineBrowser() {
      return /line/.test(this.userAgent)
    },
  },

  methods: {
    getImage(data) {
      return `${this.$store.getters['env/GET_KEY'](ENV_KEY.IMAGE_API)}/${data.product_image}`
    },
    goToLpCart() {
      const productIds = this.data.order_item.map((item) => item.product_id)
      window.location.href = `${this.$store.getters['env/GET_KEY'](
        ENV_KEY.BASE_URL
      )}/lpc/cart?id=${productIds.join()}&is_sub=0&bgi=1&adcd=cart&nonhd=1`
    },
    handleExportClick() {
      this.visibleDeliverySlipDownloadDialog = true
    },
    async exportDeliverySlip() {
      this.loading = true
      const orderId = this.data.id
      const params = {
        template_type: TEMPLATE_TYPE_NAME.DELIVERY_SLIP,
        file_type: FILE_PATH_TEMPLATE,
      }
      try {
        const response = await FileService.exportPdf(orderId, params)
        let type = 'application/pdf'
        if (!/iphone|ipad|ipod/.test(this.userAgent) && !/chrome/.test(this.userAgent)) {
          type = 'application/octet-stream'
        }
        downloadFile(response, `${orderId}.pdf`, type)
      } catch (error) {
        this.handleError({ message: this.$t('ec-line009.purchaseInfo.deliverySlipDownloadException') })
      } finally {
        this.loading = false
        this.visibleDeliverySlipDownloadDialog = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/ec-line009/purchase-items.scss';
</style>
